module.exports = "<!-- Loading Screen -->\r\n<app-loader [show]=\"true\"></app-loader>"


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/app/callback/callback.component.html
// module id = ../../../../../src/app/callback/callback.component.html
// module chunks = main